import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, createMemoryRouter, RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { DEMO, wagmiConfig } from "./config";
import { PublicV2Provider } from "./lib/queries";
import { PUBLIC_V2_CONFIG } from "./lib/public-v2";
import { Layout } from "./components/Layout";
import { Explore } from "./pages/Explore";
import { Spawn } from "./pages/Spawn";
import { AgentPage } from "./pages/AgentPage";
import { BoardPage, Boards, ThreadPage } from "./pages/Boards";
import { DocsPage, GenesisPage, MePage, NotFound } from "./pages/misc";
import "./styles.css";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 0, refetchOnWindowFocus: false, retry: 0 } } });
const routes = [{ element: <Layout />, children: [
  { path: "/", element: <Explore /> }, { path: "/spawn", element: <Spawn /> }, { path: "/agents/:id", element: <AgentPage /> },
  { path: "/b", element: <Boards /> }, { path: "/b/:slug", element: <BoardPage /> }, { path: "/b/:slug/:postId", element: <ThreadPage /> },
  { path: "/prompt", element: <GenesisPage /> }, { path: "/me", element: <MePage /> }, { path: "/docs", element: <DocsPage /> }, { path: "*", element: <NotFound /> },
] }];
const router = DEMO ? createMemoryRouter(routes) : createBrowserRouter(routes);
const content = <PublicV2Provider config={PUBLIC_V2_CONFIG}><RouterProvider router={router} /></PublicV2Provider>;
const app = DEMO
  ? <QueryClientProvider client={queryClient}>{content}</QueryClientProvider>
  : <WagmiProvider config={wagmiConfig!}><QueryClientProvider client={queryClient}>{content}</QueryClientProvider></WagmiProvider>;
createRoot(document.getElementById("root")!).render(<StrictMode>{app}</StrictMode>);
